import { useQuery } from '@tanstack/react-query';
import { Id } from '@common/types';
import { downloadNoteFile } from '@common/services/submissionService';
import { FileRoles } from '@common/features/document/types';

export const useDownloadNoteFile = (taskId: Id, noteId: number, fileRole?: FileRoles) => {
  const queryParams = {
    fileRole: fileRole!,
  }

  const { data, refetch } = useQuery(['downloadNoteFile', taskId, noteId, fileRole], () => downloadNoteFile(taskId, noteId, queryParams), {
    enabled: false,
  });

  return { noteFile: data, refetchDownloadNoteFile: refetch };
};
